import ForgotPasswordForm from '@/components/forms/auth/ForgotPasswordForm'
import { Meta } from '@cfs-fixings/shared'

function ForgotPasswordPage () {
  return <>
    <Meta title="Forgot Password" />

    <div className="flex justify-center w-full mt-[110px]">
      <ForgotPasswordForm />
    </div>
  </>
}

export default ForgotPasswordPage
